export default __webpack_public_path__ + "static/media/documents.0f42e6de.svg";